import {$qs} from '../../@shared/ts/dom';
import {type WCPHPData} from '../../@type/woocommerce/php-data';
import {peachpay_addCustomMerchantStyles, peachpay_hideLoadingSpinner, shouldLoadButtonBasedOnAccountSettings, peachpay_initButton} from './button';
import {peachpay_isElementor} from './product-page';
import {peachpayButtonTemplate} from './templates/button';

declare const peachpay_data: WCPHPData;

document.addEventListener('DOMContentLoaded', pp_placeButtonCheckoutPage);

function checkoutBorderRemoval() {
	const container = $qs('.checkout-container');
	if (!container) {
		return;
	}

	container.style.border = 'none';
	container.style.boxShadow = 'none';
}

function pp_placeButtonCheckoutPage() {
	if (!peachpay_data.is_checkout_page || peachpay_data.checkout_page_hide) {
		return;
	}

	if (!shouldLoadButtonBasedOnAccountSettings()) {
		return;
	}

	const buttonContainer = `
		<div class="checkout-container ${(peachpay_data.test_mode && !peachpay_data.wp_admin_or_editor) ? 'hide' : ''}">
			<h2 class="checkout-header">${peachpay_data.header_text_checkout_page}</h2>
			${peachpayButtonTemplate()}
			<p class="peachpay-description">
				${peachpay_data.subtext_text_checkout_page}
			</p>
		</div>
	`;

	const selector = peachpay_data.custom_button_placement.checkout_page;
	const $checkoutForm = selector ? $qs(selector) : $qs('form.checkout');
	if (!$checkoutForm) {
		// The receipt page is also considered the checkout page, but we cannot
		// add the button there.
		return;
	}

	$checkoutForm.insertAdjacentHTML('beforebegin', buttonContainer);

	// We must do this because we changed the <img> tags to <object> tags to
	// fix a Safari issue where it would not load animated SVGs. If we have
	// the hide class on the element right away, the SVG is not loaded, so the
	// first time you click the button it's not there. Only after it is visible
	// does it load, so we allow it to be visible for a split second before
	// hiding it here.
	peachpay_hideLoadingSpinner();

	const full = peachpay_data.button_alignment_checkout_page === 'full';
	const width = full ? '100%' : ((peachpay_data.button_width_checkout_page || '320') + 'px');

	peachpay_initButton({
		width,
		alignment: peachpay_data.button_alignment_checkout_page,
		borderRadius: peachpay_data.button_border_radius,
	});

	if (!peachpay_isElementor() && !peachpay_data.display_checkout_outline) {
		checkoutBorderRemoval();
	}

	peachpay_addCustomMerchantStyles();
}
